import { useState } from 'react';
import bem from '../../../../utils/bem';
import Icon from '../../Icon/Icon';

const FilterAccordion = ({ label, expanded = true, children, mods = [] }) => {
  const baseClass = 'filter-accordion';
  const [isExpanded, setExpanded] = useState(expanded);

  if (!label) {
    return '';
  }

  return (
    <div className={bem(baseClass, mods)}>
      <button
        className={bem('heading', [], baseClass, ['btn-icon'])}
        aria-expanded={isExpanded}
        onClick={() => setExpanded(!isExpanded)}
      >
        <h6>{label}</h6>
        <Icon iconName={isExpanded ? 'minus' : 'plus'} />
      </button>
      <div
        className={bem('content', [], baseClass, [
          `${isExpanded ? 'expanded' : ''}`,
        ])}
        aria-hidden={!isExpanded}
        style={{ maxHeight: !isExpanded ? '0' : '' }}
      >
        <div>{children}</div>
      </div>
    </div>
  );
};

export default FilterAccordion;
